<template>
  <div class="px-8 pt-4 pb-2" :class="{ isEditing }">
    <v-row>
      <v-col cols="12" md="4">
        <radio-options
            :label="`Does Client currently homeless?`"
            v-model="housing.homeless"
            :options="yesNoOptions"
            row
            :readonly="readonly"
          />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
            ref="comment"
            v-model="getFullAddress"
            label="Current Address"
            placeholder=" "
            :readonly="true"
            :outlined="false"
          />
      </v-col>
      <v-col cols="12" md="4">
        <text-field
            :label="`How long have client lived at this address?`"
            v-model="housing.currentAddress.howLong"
            :readonly="readonly"
          />        
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="housing.currentAddress" cols="12" md="4">
        <radio-options
            :label="`Does Client  currently facing an eviction?`"
            v-model="housing.currentAddress.faceEviction"
            :options="yesNoOptions"
            row
            :readonly="readonly"
          />        
      </v-col> 
      <v-col v-if="housing.currentAddress.faceEviction" cols="12" md="4">
        <radio-options
            :label="`Is there a court date set?`"
            v-model="housing.currentAddress.courtDateSet"
            :options="yesNoOptions"
            row
            :readonly="readonly"
          />        
      </v-col>
      <v-col v-if="housing.currentAddress.faceEviction && housing.currentAddress.courtDateSet" cols="12" md="4">
      <date-field
          label="Is there a court date set?"
          v-model="housing.currentAddress.courtDate"
          :date-menu-attrs="{
            'offset-y': true,
            top: true
          }"
          year-picker
          :readonly="readonly"
        />  
      </v-col>                   
    </v-row>    
    <v-row>
      <v-col cols="12" md="4">
        <radio-options
            v-model="housing.currentAddress.utilityStatus"
            label="Are any of Client utilities shut off right now?"
            :options="yesNoOptions"
            row
            :readonly="readonly"
          /> 
      </v-col>
      <v-col v-if="!housing.currentAddress.utilityStatus" cols="12" md="4">
        <radio-options
            v-model="housing.currentAddress.utilityShutOffNotice"
            label="Is there a Shutoff notice for any of your utilities?"
            :options="yesNoOptions"            
            placeholder=" "
            :readonly="readonly"
          />
      </v-col>
      <v-col  v-if="housing.currentAddress.utilityShutOffNotice" cols="12" md="4">
        <date-field
          label="Date of scheduled shutoff"
          v-model="housing.currentAddress.shutOffDate"
          :date-menu-attrs="{
            'offset-y': true,
            top: true
          }"
          year-picker
          :readonly="readonly"
        />
      </v-col>              
    </v-row>
    <div v-if="housing.houseHolds" class="pt-6 px-6">
      <span
            class="subtitle-1"
            v-html="'House Holds'"
          />      
      <v-data-table
        class="dataTable"
        :headers="headers"
        :items="housing.houseHolds"
        hide-default-footer
        disable-pagination
        disable-filtering
        disable-sort
        :loading="loading"
        loading-text="Loading... Please wait"
      >
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import formatters from '@/helpers/formatters'
import { YES_NO_OPTIONS } from '@/constants'
import TextField from '@/components/form/TextField'
import AdsTextArea from '@/components/app/AdsTextArea'
import SelectField from '@/components/form/SelectField'
import AdsFormatContactField from '@/components/app/AdsFormatContactField'
import MultiSelectField from '@/components/form/MultiSelectField'
import DateField from '@/components/form/DateField'
import ReadOnlyField from '@/components/form/ReadOnlyField'
import RadioOptions from '@/components/form/RadioOptions'
import { GENDER_OPTIONS, DATE_OF_BIRTH_MINIMUM_YEAR } from '@/constants'

function dateToIsoDate(date) {
  return date.toISOString ? date.toISOString().slice(0, 10) : null
}

export default {
  name: 'HousingDetails',
  components: {
    TextField,
    AdsTextArea,
    SelectField,
    MultiSelectField,
    DateField,
    ReadOnlyField,
    RadioOptions,
    AdsFormatContactField,
  },
  props: {
    readonly: {
      type: Boolean,
      defaiult: true
    }
  },
  data() {
    const sevenDaysAgo = new Date()
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

    const startOfThisYear = new Date()
    startOfThisYear.setDate(1)
    startOfThisYear.setMonth(0)

    const endOfNextYear = new Date()
    endOfNextYear.setMonth(11, 31) // zero based months!
    endOfNextYear.setFullYear(startOfThisYear.getFullYear() + 1)

    const thisYear = new Date().getFullYear()
    const minAttendedYear = thisYear -16
    const maxAttendedLastDate = `${thisYear.toString()}-12-31`

    return {
      headers: [
        { text: 'Name', value: 'name' },        
        { text: 'Birth Date', value: 'dob', width: '120px' },
        { text: 'Age', value: 'age' },
        { text: 'Relationship', value: 'relationship' },
        { text: 'Employed', value: 'employed' }
      ],
      MONTH_YEAR_DATE_FORMAT: 'MM-YYYY',
      minBirthDate: `${thisYear - DATE_OF_BIRTH_MINIMUM_YEAR}-01-01`,
      sevenDaysAgo: dateToIsoDate(sevenDaysAgo),
      endOfNextYear: dateToIsoDate(endOfNextYear),
      yesNoOptions: YES_NO_OPTIONS,
      boolYesNo: formatters.boolYesNo,
      genderOptions: GENDER_OPTIONS,
      minAttendedStartDate: new Date(`${minAttendedYear}-01-01`).toISOString().slice(0, 10),
      maxAttendedStartDate: new Date().toISOString().slice(0, 10),
      maxAttendedLastDate,
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'application', 
      'isEditing', 
      'referenceData'
    ]),
    client() {
      return this.application.application.client
    },
    housing() {
      return this.application.application.housing
    },
    getFullAddress() {
      return this.housing.currentAddress.street+', '+this.housing.currentAddress.county+', '+this.housing.currentAddress.state  
    },
  },
  methods: {

  }
}
</script>
